import { api } from "../api";

/**
 * findAllVehicleBrandsListResponse - Function that finds on database all vehicles brands as select list response   
 * /vehicles/brands  
 * method GET 
 * @async-function
 */
const findAllVehicleBrandsListResponse = async (token: string) => {
    const response = await api.get(
        `/vehicles/brands`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
         }
    );
    return response;
};

export default findAllVehicleBrandsListResponse;